var m = require('mithril');
var prop = require('mithril/stream')
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var dragscroll = require('../../libs/dragscroll');
var Model = require('../../libs/Model');
var loaders = require('../../layout/components/loaders');
var paginationWithSearch = require('../../data/components/paginationWithSearch');

var addMemberModal = {};

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function getMembers(record) {
  return Array.isArray(record && record.members) ? record.members : [];
}

function getMemberRid(record) {
  return record && record['@rid'];
}

function getDraftMemberIndex(record) {
  var rid = getMemberRid(record);
  return addMemberModal.draftMembers.findIndex(function (memberRecord) {
    return getMemberRid(memberRecord) === rid;
  });
}

function isDraftMember(record) {
  return getDraftMemberIndex(record) !== -1;
}

addMemberModal.editDialogue = function (record, options) {
  addMemberModal.record = record;
  addMemberModal.draftMembers = getMembers(record).slice();
  addMemberModal.newNode = prop(false);
  addMemberModal.usersToShow = [];
  addMemberModal.users = [];
  addMemberModal.loading = prop(true);
  addMemberModal.loadError = prop('');
  addMemberModal.saveError = prop('');

  addMemberModal.loadUsers = function () {
    addMemberModal.loading(true);
    addMemberModal.loadError('');
    return loaders.requestWithLoader({
      loader: 'background',
      url: "/api/v1/user",
      method: 'GET'
    })
    .then(function (users) {
      users.forEach(function (user) { user.name = user.firstName + ' ' + user.lastName; });
      users.sort(function (a, b) { return a.name.localeCompare(b.name); });
      users.sort(function (a, b) {
        var aIndex = getDraftMemberIndex(a);
        var bIndex = getDraftMemberIndex(b);

        if (aIndex === -1 && bIndex === -1) {
          return 0;
        } else if (aIndex === -1) {
          return 1;
        } else if (bIndex === -1) {
          return -1;
        }
        return aIndex - bIndex;
      });
      addMemberModal.users = users;
      addMemberModal.newNode(true);
      addMemberModal.loading(false);
      m.redraw();
      return users;
    })
    .catch(function (error) {
      console.error('Unable to load users for group membership:', error);
      addMemberModal.users = [];
      addMemberModal.usersToShow = [];
      addMemberModal.newNode(true);
      addMemberModal.loading(false);
      addMemberModal.loadError('Unable to load users. Please try again.');
      m.redraw();
      // Opening the modal does not have a caller that can catch a rejection.
      return null;
    });
  };

  addMemberModal.loadUsers();

  var submit = function () {
    addMemberModal.saveError('');
    return loaders.requestWithLoader({
      method: 'PUT',
      url: '/api/v1/group/' + addMemberModal.record['@rid'].slice(1),
      body: {
        name: addMemberModal.record.name,
        members: addMemberModal.draftMembers.map(r => r['@rid'])
      }
    }).then(response=>{
      addMemberModal.record.members = addMemberModal.draftMembers.slice();
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    }).catch(function (error) {
      console.error('Unable to update group members:', error);
      addMemberModal.saveError('Unable to update group members. Please try again.');
      m.redraw();
      throw error;
    })
  };

  key.setScope('modal');
  key('enter', 'modal', function () {
    return submit().catch(function () { return null; });
  });

  modal.vm.title("Add Member");
  modal.vm.body = view;
  modal.vm.buttons([
    {
      label: "Save",
      class: "dib",
      func: submit
    }
  ])

  modal.vm.open()
};


addMemberModal.addUser = function(record){
  if (!isDraftMember(record)) addMemberModal.draftMembers.push(record)
}

addMemberModal.removeUser = function(record){
  addMemberModal.draftMembers = addMemberModal.draftMembers.filter(r => r['@rid'] != record['@rid']);
}

function view () {
  if (addMemberModal.loading && addMemberModal.loading()) {
    return m('div.tc.pv3', [
      m('img.loading', { src: '/images/loading-bars.svg' })
    ]);
  }

  if (addMemberModal.loadError && addMemberModal.loadError()) {
    return m('div.red', { role: 'alert' }, [
      m('div', addMemberModal.loadError()),
      m('button.mt3', {
        type: 'button',
        onclick: addMemberModal.loadUsers
      }, 'Retry')
    ]);
  }

  return m('div',[
    addMemberModal.saveError && addMemberModal.saveError() ?
      m('div.red.mb3', { role: 'alert' }, addMemberModal.saveError())
      :
      '',
    m(paginationWithSearch, {
      data: addMemberModal.users,
      newNode: addMemberModal.newNode,
      dataToShow: addMemberModal.usersToShow,
      placeHolder: 'Search user',
      itemsPerPage: 20,
      fieldsToSearch: ['firstName', 'email', 'lastName']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.mt2', [
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tl', 'Name'),
                  m('th.ph0.tl', 'Email'),
                  m('th.ph0.tl', 'Membership'),
                ])
              ]),
              m('tbody', [
                addMemberModal.usersToShow.map(function (user) {
                  if(!user['@rid']){
                    return m('tr', [
                      m('td.tl', [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data')
                      ]),
                      m('td.tl'),
                      m('td.tl')
                    ])
                  }else{
                    return m('tr', [
                      m('td.tl.nowrap', user.name),
                      m('td.tl', user.email),
                      m('td.tl', [
                        function (){
                          return isDraftMember(user) ? 
                            m('i.f2.ml2.ion-android-checkbox-outline.green.pointer', {
                              onclick: ()=> addMemberModal.removeUser(user)
                            }) 
                          : 
                            m('i.f2.ml2.ion-android-checkbox-outline-blank.gray.pointer', {
                              onclick: ()=> addMemberModal.addUser(user)
                            });
                        }()
                      ])
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}

addMemberModal._private = {
  getDraftMembers: function () {
    return addMemberModal.draftMembers;
  },
  isDraftMember: isDraftMember,
  loadUsers: function () {
    return addMemberModal.loadUsers();
  },
  getLoadError: function () {
    return addMemberModal.loadError();
  },
  getSaveError: function () {
    return addMemberModal.saveError();
  }
};

module.exports = addMemberModal;
